import React, { createRef, useEffect, useMemo, useRef } from 'react'
import { Link, navigate, useStaticQuery, graphql } from 'gatsby'
import '../style.scss'

export default function Pagination({ location }) {
  const data = useStaticQuery(graphql`
    query getAllArtist {
      allArtist(sort: { order: ASC, fields: seq }) {
        nodes {
          name
          id
        }
      }
    }
  `)
  const list = useMemo(
    () => data.allArtist.nodes.map((a) => '/' + a.name),
    [data]
  )
  const current = list.indexOf(location)
  const scroll = useRef({
    canMove: true,
    timer: null,
    current: current,
    touchStartPos: null,
  })
  /**@param {"up"|"down"} dir*/
  const movePage = (dir) => {
    if (dir === 'up') {
      const target = scroll.current.current - 1
      if (target >= 0) {
        navigate(list[target])
      } else {
        navigate('/')
      }
    }
    if (dir === 'down') {
      const target = scroll.current.current + 1
      if (target < list.length) {
        navigate(list[target])
      } else {
        thankyou.current.ref.current.classList.remove('out')
        thankyou.current.timer = setTimeout(() => {
          thankyou.current.ref.current.classList.add('out')
        }, 2000)
      }
    }
  }
  const onWheel = (e) => {
    if (e.target.closest('.disable-page-scroll')) {
      return
    }
    if (scroll.current.canMove) {
      clearTimeout(scroll.current.timer)
      scroll.current.timer = setTimeout(() => {
        scroll.current.canMove = true
      }, 1000)
      scroll.current.canMove = false
      if (e.deltaY > 0) {
        movePage('down')
      } else if (e.deltaY < 0) {
        movePage('up')
      }
    }
  }
  /**@param {TouchEvent} e */
  const onTouchStart = (e) => {
    scroll.current.touchStartPos = e.touches[0].clientY
  }
  /**@param {TouchEvent} e */
  const onTouchEnd = (e) => {
    if (e.target.closest('.disable-page-scroll')) {
      return
    }
    if (e.changedTouches[0].clientY - scroll.current.touchStartPos > 50) {
      movePage('up')
    } else if (
      e.changedTouches[0].clientY - scroll.current.touchStartPos <
      -50
    ) {
      movePage('down')
    }
  }
  const thankyou = useRef({
    ref: createRef(),
    timer: null,
  })
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    window.addEventListener('wheel', onWheel)
    window.addEventListener('touchstart', onTouchStart)
    window.addEventListener('touchend', onTouchEnd)
    return () => {
      document.body.classList.remove('move-down')
      document.body.classList.remove('move-up')
      clearTimeout(scroll.current.timer)
      clearTimeout(thankyou.current.timer)
      window.removeEventListener('wheel', onWheel)
      window.removeEventListener('touchstart', onTouchStart)
      window.removeEventListener('touchend', onTouchEnd)
    }
  }, [])
  const prevLocation = useRef(location)
  useEffect(() => {
    scroll.current.current = current
    thankyou.current.ref.current.classList.add('out')
    if (list.indexOf(location) < 0) {
      if (location === '/') {
        document.body.classList.add('move-down')
        document.body.classList.remove('move-up')
      } else {
        document.body.classList.remove('move-down')
        document.body.classList.remove('move-up')
      }
    } else if (list.indexOf(prevLocation.current) < current) {
      document.body.classList.remove('move-down')
      document.body.classList.add('move-up')
    } else if (list.indexOf(prevLocation.current) > current) {
      document.body.classList.add('move-down')
      document.body.classList.remove('move-up')
    }
    prevLocation.current = location
  }, [location])
  return (
    <div>
      <div className={`pagination ${current < 0 ? 'out' : ''}`}>
        <Link
          to={current - 1 >= 0 ? list[current - 1] : location}
          className={current - 1 >= 0 ? 'active' : 'disabled'}
        >
          ↑
        </Link>
        <br />
        {data.allArtist.nodes.map((a) => (
          <Link to={'/' + a.name} key={a.id}>
            -
          </Link>
        ))}
        <br />
        <Link
          to={current + 1 < list.length ? list[current + 1] : location}
          className={current + 1 < list.length ? 'active' : 'disabled'}
        >
          ↓
        </Link>
      </div>
      <div className="thankyou out" ref={thankyou.current.ref}>
        <div className="w-full flex justify-center pointer-events-visible">
          <Link to="/">↑</Link>
        </div>
        <div className="w-full flex justify-between align-center mtm pointer-events-visible">
          <span className="logo hidden block">
            SSS<sup>*</sup>
          </span>
          <span className="text block">
            THANK-YOU-FOR-ATTENDING-THE-EXHIBITION
          </span>
          <span className="logo block">
            SSS<sup>*</sup>
          </span>
        </div>
      </div>
    </div>
  )
}
